import React from 'react'

import {
  Fieldset,
  Input,
  Layout,
  RadioButton,
  FormFieldRadioButtonGroup,
  Checkbox,
  InfoIcon,
  ErrorMessage,
} from '@vwfs-bronson/bronson-react'
import get from 'lodash/get'
import { Select } from '../../../components/Select'
import { FormField } from '../../../components/FormField'
import { InputDate } from '../../../components/InputDate/InputDate'
import { Field } from 'formik'

export const hasPartnerStatus = ['Casado(a)', 'União de Facto']

const Salutation = ({
  t,
  values,
  setFieldValue,
  dataModels: { salutationsList },
  autoComplete = 'honorific-prefix',
}) => (
  <Fieldset.Row>
    <Field name="salutation">
      {({ field, form }) => (
        <FormFieldRadioButtonGroup
          testId="salutation"
          id="salutation"
          labelText={t('personal-details:salutation')}
          errorMessage={
            get(form.errors, 'salutation') &&
            get(form.touched, 'salutation') ? (
              <ErrorMessage id="salutation">
                {get(form.touched, 'salutation') &&
                  get(form.errors, 'salutation')}
              </ErrorMessage>
            ) : (
              ''
            )
          }
        >
          {salutationsList.map((item) => {
            const radioId = `salutation-${item.value}`
            return (
              <RadioButton
                required
                {...field}
                name="salutation"
                key={item.value}
                id={radioId}
                checked={values.salutation === item.value}
                onChange={() => setFieldValue('salutation', item.value)}
                aria-describedby={`error-salutation`}
                autoComplete={autoComplete}
                error={
                  !!(get(form.touched, 'salutation')
                    ? get(form.errors, 'salutation')
                    : undefined)
                }
              >
                {item.label}
              </RadioButton>
            )
          })}
        </FormFieldRadioButtonGroup>
      )}
    </Field>
  </Fieldset.Row>
)

const Title = ({ t, dataModels: { titles }, autoComplete = 'off' }) => (
  <FormField
    testId="title"
    type="select"
    name="title"
    labelText={t('personal-details:titleLabel')}
    render={(fieldProps) => (
      <Select
        defaultOption
        values={titles}
        {...fieldProps}
        autoComplete={autoComplete}
      >
        {titles.map(({ value, label }) => (
          <Select.Item key={`${value}${label}`} value={value}>
            {label}
          </Select.Item>
        ))}
      </Select>
    )}
  />
)

const FirstName = ({ t }) => (
  <FormField
    testId="firstName"
    type="input"
    name="firstName"
    labelText={t('personal-details:firstName')}
    render={(fieldProps) => (
      <Input
        {...fieldProps}
        aria-describedby={`error-${fieldProps.name}`}
        id={fieldProps.name}
        required
        autoComplete="given-name"
      />
    )}
  />
)

const LastName = ({ t }) => (
  <FormField
    testId="lastName"
    type="input"
    name="lastName"
    labelText={t('personal-details:lastName')}
    render={(fieldProps) => (
      <Input
        {...fieldProps}
        aria-describedby={`error-${fieldProps.name}`}
        id={fieldProps.name}
        required
        autoComplete="family-name"
      />
    )}
  />
)

const DateOfBirth = ({ t }) => (
  <FormField
    testId="dateOfBirth"
    type="other"
    name="dateOfBirth"
    ariaLabelInfoIcon={t('personal-details:dateOfBirth_title')}
    labelText={t('personal-details:dateOfBirth')}
    infoIcon={t('personal-details:dateOfBirth_tooltip')}
    render={(fieldProps) => (
      <InputDate
        {...fieldProps}
        aria-describedby={`error-${fieldProps.name}`}
        id={fieldProps.name}
        required
        autoComplete="bday"
      />
    )}
  />
)

const LicenseCheckbox = ({ t, values, storefrontData }) => (
  <FormField
    testId="licenseCheck"
    type="checkbox"
    name="licenseCheck"
    showErrorMessageFormField={false}
    render={(fieldProps) => (
      <Checkbox
        {...fieldProps}
        id={fieldProps.name}
        errorMessage={
          fieldProps.error ? t('validation:licenseCheckError') : null
        }
        checked={get(values, 'licenseCheck', '')}
        required
        autoComplete="off"
      >
        {storefrontData?.vehicleData?.minDurationDriverLicense > 0
          ? t('personal-details:licenseCheck:filled:label', {
              minDurationDriverLicense:
                storefrontData?.vehicleData?.minDurationDriverLicense,
            })
          : t('personal-details:licenseCheck:empty:label')}
        <InfoIcon
          icon="semantic-info"
          aria-label={t(
            'personal-details:licenseCheck.filled.licenseCheck_title'
          )}
        >
          {storefrontData?.vehicleData?.minDurationDriverLicense > 0
            ? t('personal-details:licenseCheck:filled:tooltip')
            : t('personal-details:licenseCheck:empty:tooltip')}
        </InfoIcon>
      </Checkbox>
    )}
  />
)

const RenderFieldset = (
  t,
  dataModels,
  values,
  setFieldValue,
  storefrontData
) => {
  return (
    <Fieldset>
      <Fieldset.Row>
        <Layout>
          <Layout.Item default="1/2" s="1/1">
            <Salutation
              t={t}
              values={values}
              setFieldValue={setFieldValue}
              dataModels={dataModels}
            />
          </Layout.Item>
          <Layout.Item default="1/2" s="1/1">
            <Title t={t} dataModels={dataModels} />
          </Layout.Item>
          <Layout.Item default="1/2" s="1/1">
            <FirstName t={t} />
          </Layout.Item>
          <Layout.Item default="1/2" s="1/1">
            <LastName t={t} />
          </Layout.Item>
          <Layout.Item default="1/2" s="1/1">
            <DateOfBirth t={t} />
          </Layout.Item>
          <Layout.Item default="1/1" s="1/1">
            <LicenseCheckbox
              t={t}
              values={values}
              storefrontData={storefrontData}
            />
          </Layout.Item>
        </Layout>
      </Fieldset.Row>
    </Fieldset>
  )
}

export default RenderFieldset
